"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "100+",
  description: "families supported through birth and beyond"
}, {
  value: "2",
  description: "certified birth doula and lactation counselor"
}, {
  value: "100%",
  description: "dedicated West Palm Beach native heart"
}];
function AnimatedStat({
  value,
  description,
  index
}: {
  value: string;
  description: string;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  const numericValue = parseInt(value.replace(/[^0-9]/g, ""), 10);
  const suffix = value.replace(/[0-9]/g, "");
  useEffect(() => {
    if (isVisible) {
      let startTimestamp: number | null = null;
      const duration = 800;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const easeOutProgress = progress * (2 - progress);
        setCount(Math.floor(easeOutProgress * numericValue));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          setCount(numericValue);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [isVisible, numericValue]);
  return <div data-section-id="223977" ref={ref} data-index={index} className="flex flex-col items-center justify-center space-y-4 px-4">
      <div className="text-6xl font-bold tracking-tighter !text-[rgba(245,242,239,1)] !font-serif md:text-7xl lg:text-8xl">
        {count}
        {suffix}
      </div>
      <p className="text-lg font-default max-w-[220px] leading-snug mx-auto uppercase tracking-wider !text-[rgba(245,242,239,1)] md:text-xl">
        {description}
      </p>
    </div>;
}
export default function StatsSection() {
  return <section id="certifications-heart" className="py-24 md:py-32 bg-primary">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 text-center">
          {stats.map((stat, i) => <AnimatedStat key={i} index={i} value={stat.value} description={stat.description} />)}
        </div>
      </div>
    </section>;
}